import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../../shared/base-api-template-service.model';
import { Core2Config } from '../../../shared/core2Config';
import { ApiVisa } from '../../../shared';
import { ApiResponseModel } from '../../../shared/api-response.model';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class DeliveryJobLineReportService extends BaseApiTemplateService<any> {
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-line-report';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-line-report';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-line-report';
    this.httpClient = http;
  }

 
  public getReportsByCriteria(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/backoffice-ep/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public printDeliveryJobLineReportPDF(dtoObject: any, printableFormatHdrGuid:String, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/jasper-pdf-delivery-job-line/backoffice-ep?printableFormatHdrGuid='+printableFormatHdrGuid;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeaderBlob(visa)
    );
  }

}
